var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1189 9.3998L9.87891 5.2198C8.95195 4.68462 7.81007 4.68385 6.8824 5.21778C5.95472 5.75171 5.38179 6.73945 5.37891 7.8098V16.1898C5.38179 17.2602 5.95472 18.2479 6.8824 18.7818C7.81007 19.3158 8.95195 19.315 9.87891 18.7798L17.1189 14.5998C18.049 14.0644 18.6222 13.073 18.6222 11.9998C18.6222 10.9266 18.049 9.93519 17.1189 9.3998Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/Play.6b1340a504b4103bf37a5f5b1919b320.svg";
export { ForwardRef as ReactComponent };